import { render, staticRenderFns } from "./SafeDigForgotPassword.vue?vue&type=template&id=6cd354bc&scoped=true"
import script from "./SafeDigForgotPassword.vue?vue&type=script&lang=js"
export * from "./SafeDigForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./SafeDigForgotPassword.vue?vue&type=style&index=0&id=6cd354bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd354bc",
  null
  
)

export default component.exports